import React, { useMemo } from "react";
import Row from "./Row";
import SkeletonRow from "../../../../../../../components/skeleton-loader/table/row";
import style from "./style.module.scss";
import { formatCurrency } from "../../../../../../../../components/helper/helper";

function parseAmount(value) {
  if (value === null || value === undefined || value === "") {
    return 0;
  }
  const n =
    typeof value === "string"
      ? Number(String(value).replace(/[^0-9.-]+/g, ""))
      : Number(value);
  return Number.isFinite(n) ? n : 0;
}

function BatchDataTable({
  data = [],
  loading,
  totals: apiTotals = null,
  onRowDownload,
  downloadingRowId,
  isAnyDownloading,
}) {
  const tableData = Array.isArray(data) ? data : [];

  const totals = useMemo(() => {
    if (apiTotals) {
      return apiTotals;
    }

    return tableData.reduce(
      (acc, row) => {
        acc.trans_cnt += parseAmount(row?.trans_cnt);
        acc.key_entry_cnt += parseAmount(row?.key_entry_cnt);
        acc.sales += parseAmount(row?.sales);
        acc.returns += parseAmount(row?.returns);
        acc.net_amt += parseAmount(row?.net_amt);
        acc.adjustment_amt += parseAmount(row?.adjustment_amt);
        return acc;
      },
      {
        trans_cnt: 0,
        key_entry_cnt: 0,
        sales: 0,
        returns: 0,
        net_amt: 0,
        adjustment_amt: 0,
      },
    );
  }, [apiTotals, tableData]);

  return (
    <div className={style.batch_table_container}>
      <table className={style.batch_table}>
        <thead>
          <tr className={style.header_row}>
            <th className={style.header_cell}></th>
            <th className={style.header_cell}>Batch Date</th>
            <th className={style.header_cell}>Batch Id</th>
            <th className={style.header_cell}>Terminal ID</th>
            <th className={style.header_cell}>Trans. CNT</th>
            <th className={style.header_cell}>Key Entry CNT</th>
            <th className={style.header_cell}>Sales</th>
            <th className={style.header_cell}>Returns</th>
            <th className={style.header_cell}>Net Amount</th>
            <th className={style.header_cell}>Adj Amount</th>
            <th className={style.header_cell}></th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <SkeletonRow
                key={`batch-data-skeleton-row-${index}`}
                columnLength={11}
                withBlankFirstRow
              />
            ))
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan="10" className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            <>
              {tableData.map((row, index) => (
                <Row
                  data={row}
                  key={row?.id ?? index}
                  onDownload={onRowDownload}
                  isDownloading={downloadingRowId === row?.id}
                  isAnyDownloading={isAnyDownloading}
                />
              ))}
              <tr className={`${style.table_row} ${style.total_row}`}>
                <td className={style.table_cell} />
                <td className={style.table_cell} colSpan={3}>
                  Total
                </td>
                <td className={style.table_cell}>{totals.trans_cnt}</td>
                <td className={style.table_cell}>{totals.key_entry_cnt}</td>
                <td className={style.table_cell}>$ {formatCurrency(totals.sales)}</td>
                <td className={style.table_cell}>$ {formatCurrency(totals.returns)}</td>
                <td className={style.table_cell}>$ {formatCurrency(totals.net_amt)}</td>
                <td className={style.table_cell}>$ {formatCurrency(totals.adjustment_amt)}</td>
                <td className={style.table_cell} />
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default BatchDataTable;
